import { toastContainerSchema } from '@/@types/schemas/toast-containers'
import { showError } from '@/components/toast'
import { useRouteCompanyId } from '@/hooks/use-route-company-id'
import { GetFileS3Key, UploadFileToS3ByURL } from '@/services/upload'
import { sanitizerFileName } from '@/utils/validators/files/sanitizers'

import useTranslator from '../../translation'

export const useUploadFiles = () => {
  const routeCompanyId = useRouteCompanyId()

  const { getTranslation } = useTranslator()

  const uploadFile = async (
    file: File,
    entityType: 'company' | 'project' | 'bot' | 'user',
    companyId?: string,
  ) => {
    const id = companyId || routeCompanyId

    if (!id) return null

    const mimeType = file.type

    const fileS3Key = await GetFileS3Key(id, mimeType, entityType)

    if (
      fileS3Key.statusCode < 200 ||
      fileS3Key.statusCode >= 300 ||
      !fileS3Key.data
    ) {
      showError({
        title: getTranslation('common.toast.error.imageUpload.title'),
        description: getTranslation(
          'common.toast.error.imageUpload.description',
        ),
        containerId: toastContainerSchema.Enum.GLOBAL,
      })

      return null
    }

    const { key, pre_signed_url: preSignedUrl } = fileS3Key.data

    if (!key || !preSignedUrl) {
      showError({
        title: getTranslation('common.toast.error.imageUpload.title'),
        description: getTranslation(
          'common.toast.error.imageUpload.description',
        ),
        containerId: toastContainerSchema.Enum.GLOBAL,
      })

      return null
    }

    const sanitizedFileName = sanitizerFileName(file.name)
    const sanitizedFile = new File([file], sanitizedFileName, {
      type: file.type,
    })

    const uploadFileResp = await UploadFileToS3ByURL(
      preSignedUrl,
      sanitizedFile,
    )

    if (
      uploadFileResp.statusCode < 200 ||
      uploadFileResp.statusCode >= 300 ||
      !uploadFileResp.data
    ) {
      showError({
        title: getTranslation('common.toast.error.imageUpload.title'),
        description: getTranslation(
          'common.toast.error.imageUpload.description',
        ),
        containerId: toastContainerSchema.Enum.GLOBAL,
      })

      return null
    }

    return key
  }

  return {
    uploadFile,
  }
}
